import { Box, Dialog, DialogProps } from '@mui/material'

interface DialogBoxProps extends Omit<DialogProps, 'open'> {
  children: React.ReactNode
  onClose:
    | ((event: any, reason: 'backdropClick' | 'escapeKeyDown') => void)
    | undefined
  open?: boolean
  wide?: boolean
  sx?: any
}

export function DialogBox({
  open = true,
  children,
  onClose,
  wide,
  sx,
  ...rest
}: DialogBoxProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            minWidth: '300px',
            ...(wide ? { width: '90vw', maxWidth: 'none' } : {}),
            ...sx,
          },
        },
      }}
      {...rest}
    >
      <Box sx={{ p: { xs: 3, md: 5 } }}>{children}</Box>
    </Dialog>
  )
}
